import { render } from "./EnbProduto02.vue?vue&type=template&id=bd858d1e&scoped=true"
import script from "./EnbProduto02.vue?vue&type=script&lang=js"
export * from "./EnbProduto02.vue?vue&type=script&lang=js"

import "./EnbProduto02.vue?vue&type=style&index=0&id=bd858d1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd858d1e"]])

export default __exports__